import 'slick-carousel';

function slider_products($slider, dots, arrows, slidesToShow) {
	if ($slider.length > 0) {
		let $slides = $slider.find('.slider__slides');
		let fade = true;

		if (dots == undefined) {
			dots = false;
		}

		if (arrows == undefined) {
			arrows = false;
		}

		if (slidesToShow == undefined) {
			slidesToShow = 1;
		}

		if (slidesToShow > 1) {
			fade = false;
		}

		$slides.slick({
			dots: dots,
			arrows: arrows,
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			speed: 1000,
			centerMode: false,
			variableWidth: false,
			adaptiveHeight: false,
			fade: fade,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}
			]
		});
	}
}

export default slider_products;
